"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Wifi, Utensils, Coffee, Headphones, Camera, MapPin } from "lucide-react";
const services = [];
export default function OnsiteServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="onsite-services" className="py-16 px-6 !bg-[hsl(158,54%,18%)] md:py-24 md:px-12 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className={`grid gap-8 md:grid-cols-2 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 group border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] animate-fade-in-up !bg-[hsl(215,16%,47%)] hover:shadow-medium hover:-translate-y-1" style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4">
                    <Icon className="h-12 w-12 text-accent transition-transform duration-[var(--duration-medium)] group-hover:translate-y-[-3px]" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-foreground-primary text-xl font-bold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-foreground-primary/90 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}